import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import PropTypes from 'prop-types';

const NeuroRoot = ({ AppComponent, LoadingComponent, isLoading }) => {
  return <Router>{isLoading ? <LoadingComponent /> : <AppComponent />}</Router>;
};

NeuroRoot.propTypes = {
  AppComponent: PropTypes.any,
  isLoading: PropTypes.bool,
  LoadingComponent: PropTypes.any,
};

NeuroRoot.displayName = 'NeuroRoot';

export default NeuroRoot;
